import { AxiosInstance } from 'axios';
import { ValuesToSendInterface } from '../../../types/form.types';

const postFormService = async (
  client: AxiosInstance,
  data: ValuesToSendInterface,
  recaptchaToken: string
): Promise<void> => {
  const response = await client.post(
    `/`,
    { ...data },
    { headers: { 'X-Captcha-Token': recaptchaToken }, timeout: 1000 * 60 }
  );

  return response.data;
};

export default postFormService;
